/** @format — port.recommendation AG-UI component */

import React from "react";
import { Info, Car } from "lucide-react";
import PortOptionCard from "./PortOptionCard";

export default function PortRecommendationCards({
  componentId,
  props = {},
  onAction,
  disabled,
}) {
  const options = Array.isArray(props.options) ? props.options : [];
  const title = props.title ?? "Recommended ports";
  const footnote =
    props.footnote ??
    (props.origin && props.destination
      ? `Based on similar shipments from ${props.origin} to ${props.destination}.`
      : "Based on similar shipments on this route.");

  const vehicle = props.vehicle;
  const vehicleLabel =
    vehicle?.year && vehicle?.make && vehicle?.model
      ? `${vehicle.year} ${vehicle.make} ${vehicle.model}`
      : null;

  const handleSelect = (actionId) => {
    const action = props.actions?.find((a) => a.id === actionId);
    onAction?.({
      componentId,
      actionId,
      label: action?.label ?? actionId,
      value: null,
    });
  };

  return (
    <div className="w-full min-w-0 max-w-full overflow-visible pt-1">
      <p className="text-[13px] font-semibold text-[#101928] mb-1">{title}</p>
      {vehicleLabel ? (
        <div className="flex items-center gap-1.5 text-[12px] leading-none text-[#667185] mb-2">
          <Car className="w-3.5 h-3.5 flex-shrink-0" aria-hidden />
          <span className="leading-snug">
            {vehicleLabel}
            {vehicle?.operable === false ? "" : " · operable"}
            {vehicle?.has_title ? " · has title" : ""}
          </span>
        </div>
      ) : null}
      {(props.origin || props.destination) && (
        <p className="text-[12px] text-[#667185] mb-3">
          {props.origin ? `Origin ${props.origin}` : ""}
          {props.origin && props.destination ? " — " : ""}
          {props.destination ? `Destination ${props.destination}` : ""}
        </p>
      )}

      <div className="flex gap-3 overflow-x-auto overflow-y-visible pb-3 pt-2 sm:pt-3 -mx-1 px-1 snap-x snap-mandatory scroll-smooth [-webkit-overflow-scrolling:touch]">
        {options.map((opt) => (
          <PortOptionCard
            key={opt.id}
            option={opt}
            onSelect={handleSelect}
            disabled={disabled}
          />
        ))}
      </div>

      {footnote ? (
        <div className="mt-3 flex items-center gap-1.5 text-[12px] leading-snug text-[#667185]">
          <Info className="h-3.5 w-3.5 flex-shrink-0" aria-hidden />
          <span>{footnote}</span>
        </div>
      ) : null}
    </div>
  );
}
